// Summaries API service
import { baseClient } from './baseClient';
import type { DailySummary, DailySummaryCreate } from '../types/api';

export class SummariesApi {
  private static instance: SummariesApi;

  private constructor() {}

  public static getInstance(): SummariesApi {
    if (!SummariesApi.instance) {
      SummariesApi.instance = new SummariesApi();
    }
    return SummariesApi.instance;
  }

  /**
   * Get all daily summaries
   */
  async getDailySummaries(): Promise<DailySummary[]> {
    return baseClient.get<DailySummary[]>('/summaries/');
  }

  /**
   * Get a single daily summary by ID
   */
  async getDailySummary(id: string): Promise<DailySummary> {
    return baseClient.get<DailySummary>(`/summaries/${id}`);
  }

  /**
   * Create a new daily summary
   */
  async createDailySummary(summary: DailySummaryCreate): Promise<DailySummary> {
    return baseClient.post<DailySummary>('/summaries/', summary);
  }

  /**
   * Get latest daily summary
   */
  async getLatestDailySummary(): Promise<DailySummary> {
    return baseClient.get<DailySummary>('/summaries/latest');
  }

  /**
   * Get summaries by date range
   */
  async getSummariesByDateRange(startDate: string, endDate: string): Promise<DailySummary[]> {
    const params = new URLSearchParams();
    params.append('start_date', startDate);
    params.append('end_date', endDate);
    
    return baseClient.get<DailySummary[]>(`/summaries/?${params.toString()}`);
  }

  /**
   * Get summaries by agent
   */
  async getSummariesByAgent(agent: string): Promise<DailySummary[]> {
    return baseClient.get<DailySummary[]>(`/summaries/agents/${agent}`);
  }

  /**
   * Generate new daily summary
   */
  async generateDailySummary(): Promise<DailySummary> {
    return baseClient.post<DailySummary>('/summaries/generate');
  }

  /**
   * Get summary statistics
   */
  async getSummaryStats(): Promise<any> {
    return baseClient.get<any>('/summaries/stats');
  }

  /**
   * Get summary trends
   */
  async getSummaryTrends(period: string = 'weekly'): Promise<any> {
    return baseClient.get<any>(`/summaries/trends?period=${period}`);
  }
}

// Export singleton instance
export const summariesApi = SummariesApi.getInstance(); 